import React, { useEffect, useState, useRef } from 'react'
import Icon from 'meinian-package/src/component/icon'
import classNames from 'classnames'
import { request } from 'meinian-package/src/utils'
import emitter, { EmitterEvents } from 'meinian-package/src/utils/emitter'
import styles from './index.module.less'

export const RejectCommentShow = ({ onClose, style, chidClassName, messageData, commentShowOpenType }) => {
  const allCommentData = useRef([])
  const [commentData, setCommentData] = useState()

  useEffect(() => {
    allCommentData.current = messageData.blogComment
    setCommentData(allCommentData.current[allCommentData.current.length - 1])
  }, [])

  const _onClose = async () => {
    await request.post('/zhikuan/ins/inspiration/read-user-comment', { idList: allCommentData.current?.map(item => item.id) })
    firstClose()
    onClose()
  }

  const firstClose = () => {
    const keyValue = 'mn:detail_audit_comment'
    request.get('/backend-api/sso-api/common/setting/get', { params: { key: keyValue } }).then((res) => {
      if (!JSON.parse(res)) {
        emitter.emit(EmitterEvents.firstAuditNoPassModal, true)
        request.get(`/backend-api/sso-api/common/setting/set?key=${keyValue}&value=`)
      }
    })
  }

  return <div
    style={style}
    className={classNames(styles['mn-card-reject-comment-windows-show'], chidClassName)}
    onClick={(e) => e.stopPropagation()}
  >
    <div className="mn-card-reject-comment-windows-show-label">已拒回</div>
    <div className="mn-card-reject-comment-windows-show-title">
      <div className="mn-card-reject-comment-windows-show-name text-overflow">{commentData?.userName}</div>
      <div>审核不通过并留言</div>
    </div>
    <div
      className="mn-card-reject-comment-windows-show-info text-overflow"
      onClick={() => window.open(`/meinian/detail/image?imageGroupEntityId=${messageData.blogId}&inspirationId=${messageData.inspirationId}&collectId=${messageData.collectOrSampleId}&commentId=${commentData.id}`, commentShowOpenType)}
    >{commentData?.content}</div>
    <div className="mn-card-reject-comment-windows-show-clear" onClick={_onClose}><Icon type="m-guanbi" /></div>
  </div>
}
